/**
 * Runtime app config injected by Cloud Run.
 *
 * `/config.js` is served by nginx at container start (see
 * `nginx.conf.template`). Its contents are generated from env vars
 * supplied by `--set-env-vars` on `gcloud run deploy`, which are in
 * turn sourced from GitHub Environment variables in the promote
 * workflow. Local dev has no `/config.js` (the stub in `public/` sets
 * this to undefined), so consumers must fall back to their existing
 * logic when this returns undefined.
 */
export interface RuntimeAppConfig {
  env?: 'dev' | 'stg' | 'prod';
  studioApi?: string;
  identityBroker?: string;
  wsUrl?: string;
  wsMultichannelUrl?: string;
  // Semicolon-separated list of origins allowed to embed Studio (parent
  // frames). Merged with same-origin in embedHost.ts. Semicolon (not
  // comma) so the value doesn't collide with the comma delimiter used
  // between KEY=VALUE pairs in the deploy pipeline.
  parentOrigins?: string;
}

export const getRuntimeAppConfig = (): RuntimeAppConfig | undefined => {
  if (typeof window === 'undefined') return undefined;
  return (window as Window & { APP_CONFIG?: RuntimeAppConfig }).APP_CONFIG;
};
